import { MouseEvent } from "react"
import { Trans } from "@lingui/macro"

import { focusPageStart } from "@src/utils/focusPageStart"

export const SkipLink = () => {
  const skipToMain = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    focusPageStart()
  }

  return (
    <a
      href="#main"
      onClick={skipToMain}
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-blue focus:shadow-lg focus:outline focus:outline-2 focus:outline-blue"
    >
      <Trans id="skip_to_main_content">Skip to main content</Trans>
    </a>
  )
}
